import styled from 'styled-components';
import { Anchor } from 'Components/core';

import { colors } from '../../constants';

const Button = styled(Anchor).attrs(props => ({ underline: false }))`
font-family: "Elevance Sans Bold";
 font-size: 16px;
 line-height: 22px;
 color: #fff;
 

  padding: ${props => (props.wide ? '12px 36px' : '12px 24px')};
  /*
  color: ${props =>
    props.secondary ? colors.buttonBackground : colors.textOnAccent};
    */
  background-color: ${props =>
    props.secondary ? 'transparent' : colors.buttonBackground};
  outline: none;

  border-radius: 22px;
  transition: 0.2s all;
  cursor: pointer;
  text-align: center;
  border: 2px solid #ffffff00;


  :focus{
    border: 2px solid ${colors.textDark};
    border-radius:15px ;
    color:#eaeaea ;                                 
  }

  :hover {
    border: 2px solid ${colors.buttonBackground};
    background-color: ${props =>
      props.secondary ? colors.buttonBackground : 'transparent'};
    color: ${props =>
      props.secondary ? colors.text : colors.buttonBackground};
  }
`;

export default Button;
